import { withTheme } from "@mui/styles";
import ForgotPasswordStore from "./ForgotPasswordStore";
import ForgotPasswordContainer from "./ForgotPasswordContainer";

export default ForgotPasswordStore(withTheme(ForgotPasswordContainer));